<template>
  <v-file-input
    :value="value"
    @input="$emit('input', $event)"
    :rules="rules"
    :readonly="readonly"
    rounded
    filled
    dense
    color="secondary"
    background-color="primary"
    prepend-icon="mdi-paperclip"
    v-bind="$attrs"
    v-on="$listeners"
    :multiple="multiple"
    :show-size="showSize"
    :accept="accept"
    :counter="counter"
  >
    <template v-slot:label>
      <slot name="label">{{ label }}</slot>
    </template>
    <template v-slot:selection="{ text }">
      <slot name="selection" :text="text">{{ text }}</slot>
    </template>
  </v-file-input>
</template>

<script>
export default {
  name: 'BaseInputFile',
  props: {
    label: { type: String, default: '' },
    value: [File, Array, String],
    rules: Array,
    readonly: Boolean,
    multiple: Boolean,
    showSize: Boolean,
    accept: String,
    counter: Boolean,
  },
}
</script>
